import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'atw-hover-blank-admin',
  templateUrl: './hover-blank-admin.component.html',
  styleUrls: ['./hover-blank-admin.component.scss']
})
export class HoverBlankAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
